import gql from 'graphql-tag'

import { PITCHING_CANDIDATE_FRAGMENT } from '@/components/Contacts/RecruiterFreelancer/oldGraphql/fragments'

/**
 * *** WARNING ***
 * The following is still tinkered to the old API
 */

export const QuickCreateRecruiterFreelancer = gql`
  mutation (
    $firstName: String!
    $middleName: String
    $lastName: String!
    $email: String!
    $jobTitle: String
    $currency: String!
    $rateType: RateType!
    $hourlyRate: Float
    $dailyRate: Float
    $monthlyRate: Float
    $tags: [String!]!
    $links: [String!]!
    $files: [ID!]!
  ) {
    createCandidate(
      input: {
        firstName: $firstName
        middleName: $middleName
        lastName: $lastName
        email: $email
        jobTitle: $jobTitle
        currency: $currency
        hourlyRate: $hourlyRate
        dailyRate: $dailyRate
        monthlyRate: $monthlyRate
        tags: $tags
        links: $links
        files: $files
      }
    ) {
      ...PitchingCandidateFragment
    }
  }
  ${PITCHING_CANDIDATE_FRAGMENT}
`
